import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export const GroupDestinations = () => {
  const { t, lang } = useApp();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/group-destinations").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <section id="groups" className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="group-destinations">
      <div className="text-center mb-12">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-800 mb-3">{t.sections.groupsTitle}</h2>
        <p className="text-slate-500 max-w-2xl mx-auto">{t.sections.groupsSub}</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
        {items.map((d, i) => (
          <motion.div key={d.id} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}
            className={i === 0 ? "sm:col-span-2 sm:row-span-2" : ""}>
            <Link to={`/packages?dest=${d.id}`} data-testid={`group-dest-${d.id}`}
              className={`group relative block rounded-2xl overflow-hidden card-hover ${i === 0 ? "h-full min-h-[240px] sm:min-h-[420px]" : "h-48 sm:h-52"}`}>
              <img src={d.image} alt={d[`name_${lang}`]} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-tigris-dark/90 via-tigris-dark/20 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-4 sm:p-5 text-white flex items-end justify-between gap-2">
                <div>
                  <span className="text-[11px] font-semibold text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className={`font-bold font-display ${i === 0 ? "text-2xl sm:text-3xl" : "text-lg"}`}>{d[`name_${lang}`]}</h3>
                </div>
                <span className="w-8 h-8 rounded-full bg-white/15 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><ArrowLeft size={16} className="rtl:rotate-0 ltr:rotate-180" /></span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
